import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const EmissionFactorsIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
        clipRule="evenodd"
      />
      <path
        d="M13.29 8.34c-.27.28-.49.8-.49 1.66v4.2a3.9 3.9 0 0 1-.92 2.76C11.17 17.71 10.15 18 9 18a1 1 0 1 1 0-2c.85 0 1.23-.21 1.42-.41.2-.22.38-.62.38-1.39V10c0-1.14.28-2.27 1.06-3.06.8-.83 1.96-1.11 3.28-.93a1 1 0 1 1-.28 1.98c-.88-.12-1.33.1-1.57.35Z"
        clipRule="evenodd"
      />
      <path
        d="M8 11.2a1 1 0 0 1 1-1h5.7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default EmissionFactorsIcon;
